var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "srcDownload" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "80%",
            "destroy-on-close": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "main-img" }, [
              _c("img", { attrs: { src: _vm.previewUrl, alt: "暂无预览图" } }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info" }, [
              _c("div", { staticClass: "item" }, [
                _c("label", { attrs: { for: "" } }, [_vm._v("小程序名称：")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.info.appName || "-"))]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "item" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("小程序包：")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.downloadLoading },
                      on: { click: _vm.download },
                    },
                    [_vm._v("下载小程序")]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }